export default {
  app_title: "Ceny paliw",
  fuel_label: "Paliwo",
  fuel_95: "Benzyna 95",
  fuel_98: "Benzyna 98",
  fuel_diesel: "Diesel",
  region_label: "Region",
  region_all: "Cała Hiszpania",
  list_header: "Najtańsze paliwo w okolicy",
  list_show_all: "Pokaż wszystkie",
  list_empty: "Brak stacji w tym obszarze",
  list_expand: "Rozwiń listę",
  list_collapse: "Zwiń listę",
  card_navigate: "Maps",
  locate_me: "Znajdź mnie",
  no_location_permission: "Brak zgody na lokalizację",
  loading: "Ładowanie...",
  error_loading: "Błąd ładowania danych",
  attribution: "© OpenStreetMap, CartoDB",
  expand_map: "Rozwiń mapę",
  collapse_map: "Zwiń mapę",
  station_count: "stacji",
  gesture_hint: "Użyj dwóch palców aby przesunąć mapę",
};
